import React from "react"
import { Avatar, Typography, useDimensions } from "@telavita-core/react-design-kit"

import * as S from "./styles"

interface ProfessionalInfo {
  firstName: string
  lastName: string
  pictureUrl: string
  documents: {
    typeName: string
    value: string
  }[]
}

interface ScheduleIntroProps {
  showThanksText: boolean
  patientFirstName: string
  professionalInfo: ProfessionalInfo
  professionalProfileLoading: boolean
}

function validateProfessionalInfo(professionalInfo: ProfessionalInfo) {
  if (!professionalInfo) {
    return {
      firstName: '',
      lastName: '',
      pictureUrl: '',
      documents: []
    }
  }

  return professionalInfo
}

function validatePatientFirstName(patientFirstName: string) {
  return patientFirstName 
    ? `, ${patientFirstName}` 
    : ''
}

export function ScheduleIntro({
  showThanksText,
  patientFirstName,
  professionalInfo,
  professionalProfileLoading
}: ScheduleIntroProps) {
  const { isMobile } = useDimensions()
  const validProfessionalInfo = validateProfessionalInfo(professionalInfo)
  const validPatientFirstName = validatePatientFirstName(patientFirstName)

  return (
    <S.Container isMobile={isMobile}>
      {showThanksText && (
        <Typography 
          customClassName="thanks-text"
          variant={isMobile ? "content2" : "header4"}
          center={isMobile}
        >
          Agradecemos a sua avaliação!
        </Typography>
      )}
      <Typography 
        variant={isMobile ? "header4" : "header2"}
        weight="bold"
        center={isMobile}
      >
        Vamos marcar a próxima consulta e continuar cuidando de você{validPatientFirstName}?
      </Typography>

      {professionalProfileLoading 
        ? null 
        : (
          <S.ProfessionalInfoWrapper isMobile={isMobile}>
            <Avatar 
              size="large"
              alt={`${validProfessionalInfo.firstName} ${validProfessionalInfo.lastName}`}
              src={validProfessionalInfo.pictureUrl}
            />
            <div>
              <Typography variant="content2">
                Com <strong>{validProfessionalInfo.firstName} {validProfessionalInfo.lastName}</strong>
              </Typography>
              <Typography variant="content2">
                {validProfessionalInfo.documents.map(document => (
                  <span key={document.typeName}>
                    Psicólogo(a) - {document.typeName}: {document.value}
                  </span>
                ))}
              </Typography>
            </div>
          </S.ProfessionalInfoWrapper>
        )
      }      
    </S.Container>
  )
}